import { combineReducers } from "redux";
import { Specialty } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import {
  CHANGE_SPECIALTY_WEIGHT_REQUEST,
  CREATE_SPECIALTY_REQUEST,
  FETCH_SPECIALTIES_REQUEST,
  UPDATE_SPECIALTY_REQUEST,
} from "./constants";
import { Action } from "./types";

function items(state: Specialty[] = [], action: Action): Specialty[] {
  let selected = null;
  switch (action.type) {
    case getSuccessActionType(FETCH_SPECIALTIES_REQUEST):
      return action.payload;

    case UPDATE_SPECIALTY_REQUEST:
    case CHANGE_SPECIALTY_WEIGHT_REQUEST:
      selected = state.map((specialty) =>
        specialty.id === action.data.specialtyId
          ? {
              ...specialty,
              isFetching: true,
            }
          : specialty
      );
      return selected;

    case getFailureActionType(UPDATE_SPECIALTY_REQUEST):
    case getFailureActionType(CHANGE_SPECIALTY_WEIGHT_REQUEST):
      selected = state.map((specialty) =>
        specialty.id === action.data.specialtyId
          ? {
              ...specialty,
              isFetching: false,
            }
          : specialty
      );
      return selected;

    case getSuccessActionType(UPDATE_SPECIALTY_REQUEST):
    case getSuccessActionType(CHANGE_SPECIALTY_WEIGHT_REQUEST):
      selected = state.map((specialty) =>
        specialty.id === action.data.specialtyId
          ? {
              ...action.payload,
              isFetching: false,
            }
          : specialty
      );
      return selected;

    case getSuccessActionType(CREATE_SPECIALTY_REQUEST):
      return [...state, action.payload];

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_SPECIALTIES_REQUEST:
      return true;
    case getSuccessActionType(FETCH_SPECIALTIES_REQUEST):
    case getFailureActionType(FETCH_SPECIALTIES_REQUEST):
      return false;

    case CREATE_SPECIALTY_REQUEST:
      return true;
    case getSuccessActionType(CREATE_SPECIALTY_REQUEST):
    case getFailureActionType(CREATE_SPECIALTY_REQUEST):
      return false;

    default:
      return state;
  }
}

export const specialties = combineReducers({ items, isFetching });
